/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 at.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function At(props) {
  const { nodes, materials } = useGLTF('/media/models/at.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.at.geometry} material={materials.Material} />
    </group>
  )
}

useGLTF.preload('/media/models/at.glb')
